import SentryBoundary from './SentryBoundary'

export default SentryBoundary
export * from './types'
